/**
 * 캠페인 관리 화면 집계는 커스텀 검색(ELS) 정렬용 스냅샷을 사용하지 않음.
 */
export const CAMPAIGN_AGGREGATION_METRICS_OPTS = Object.freeze({
  useMetricDetailSort: false,
});

/**
 * 포스트 객체에서 metricsSort / metricScoreSort만 제거한 얕은 복사.
 * 집계 시 실수로 정렬 스냅샷이 섞이지 않도록 한다.
 */
export function omitElsSortMetricFields(post: any) {
  if (!post || typeof post !== 'object') return post;
  const { metricsSort, metricScoreSort, ...rest } = post;
  return rest;
}
